export default "__VITE_ASSET__5dnfSlAu__"